import React from 'react';

import { GenreSimplifieDto } from 'lib_api/lib/api/gen';

import { FieldDisplay } from 'components/FieldDisplay/FieldDisplay';
import BaseModal from 'components/WrappedComponents/BaseModal';
import { BaseModalWidthUtils } from 'utils/BaseModalWidthUtils';
import { LABEL_ID_CORRELATION } from 'utils/global';

interface ModalDetailsProps {
  genreSimplifie: GenreSimplifieDto;
  visible: boolean;
  close: () => void;
}

function ModalDetails({
  genreSimplifie,
  visible,
  close,
}: ModalDetailsProps): React.ReactElement {
  return (
    <BaseModal
      width={BaseModalWidthUtils.xLargeWidth}
      isVisible={visible}
      closeModal={close}
      className="modalDetails"
    >
      <>
        <FieldDisplay
          label={LABEL_ID_CORRELATION}
          value={genreSimplifie.idCorrelation}
        />
        <FieldDisplay label="Libellé" value={genreSimplifie.libelle} />
        <FieldDisplay
          label="Dicem"
          value={genreSimplifie.dicem ? 'Oui' : 'Non'}
        />
        <FieldDisplay
          label="Formats plaque"
          value={genreSimplifie.formatsPlaque.join(', ')}
        />
      </>
    </BaseModal>
  );
}

export default ModalDetails;
